import type { ReactNode } from 'react'

interface BadgeProps {
  variant?: 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'brand'
  children: ReactNode
  size?: 'sm' | 'md'
}

const variants = {
  success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  warning: 'bg-amber-50 text-amber-700 border-amber-200',
  error: 'bg-red-50 text-red-700 border-red-200',
  info: 'bg-blue-50 text-blue-700 border-blue-200',
  neutral: 'bg-slate-100 text-slate-600 border-slate-200',
  brand: 'bg-[#e8f0fd] text-[#0a4ee3] border-[#bfcff9]',
}

const sizes = {
  sm: 'px-1.5 py-0.5 text-xs',
  md: 'px-2.5 py-0.5 text-xs',
}

export function Badge({ variant = 'neutral', size = 'md', children }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center font-medium rounded-full border ${variants[variant]} ${sizes[size]}`}
    >
      {children}
    </span>
  )
}

// Status de tenant (conta)
export function TenantStatusBadge({ status }: { status: string }) {
  const map: Record<string, { variant: BadgeProps['variant']; label: string }> = {
    active: { variant: 'success', label: 'Ativo' },
    trial: { variant: 'brand', label: 'Trial' },
    suspended: { variant: 'warning', label: 'Suspenso' },
    cancelled: { variant: 'error', label: 'Cancelado' },
  }
  const config = map[status] || { variant: 'neutral', label: status }
  return <Badge variant={config.variant}>{config.label}</Badge>
}

// Plano
export function PlanBadge({ plan }: { plan: string }) {
  const map: Record<string, { variant: BadgeProps['variant']; label: string }> = {
    starter: { variant: 'neutral', label: 'Starter' },
    pro: { variant: 'brand', label: 'Pro' },
    enterprise: { variant: 'info', label: 'Enterprise' },
  }
  const config = map[plan] || { variant: 'neutral', label: plan }
  return <Badge variant={config.variant}>{config.label}</Badge>
}
